import React from "react";
import { ToastContainer } from "react-toastify";

import { DEFAULT_CONFIG } from "@stadium/services/react-toastify/constants";

const defaultObj = {};

export const ToastContainerWrapper = ({ configs = defaultObj }) => {
  return <ToastContainer {...DEFAULT_CONFIG} {...configs} />;
};
